<template>
  <div v-if="!invalidEditParam" >
    <v-toolbar-title class='display-1 fontcolor'>Jurisdiction: {{ editedItem.name }}</v-toolbar-title>
    <v-toolbar flat id='manageTable'>
      <v-spacer></v-spacer>
      <v-btn class="mr-4" outlined dark color='red' @click='backToListingPage'>
        <v-icon dark>mdi-arrow-left</v-icon>Back to list
      </v-btn>
      <v-btn outlined class='fontcolor' @click="bulkEditUrl(jurisdictionId, '3')" >
        <v-icon dark>mdi-plus</v-icon>
        {{ADD_NEW_ADOPTION}}
      </v-btn>
    </v-toolbar>
    <v-tabs v-model="activeTab" class="locationTabsCnt tab-selected-map" >
      <v-tab key='1' >VIEW ADOPTIONS</v-tab>
      <v-tab key='2' >ADOPTION ACTIVITY</v-tab>
      <v-tab key='3' >PROFILE</v-tab>
      <!-- Tab #1 for view adoption starts -->
      <v-tab-item>
        <template v-if="jurisdictionId">
          <mapped-adoption-table
          @auditLogLoader='auditLogLoader=$event'
          @activityLogItems='activityLogItems=$event'
          :adoptionLevelFor = 'jurisdictionId'
          :adoptionLevel = '3'
          :name = 'editedItem.name'
          @resetEditDialog='editDialog = $event'>
          </mapped-adoption-table>
        </template>
      </v-tab-item>
      <!-- Tab #1 for view adoption ends -->
      <!-- Tab #2 starts -->
      <v-tab-item>
        <div class="pt-5" style="border-top:1px solid #e2e3e1" >
          <admin-activity-by-entity
          :entityTitle="editedItem.name"
          :adoptionLevel = '3'
          :name = 'editedItem.name'
          >
          </admin-activity-by-entity>
        </div>
      </v-tab-item>
      <!-- Tab #2 ends -->
      <!-- Tab #3 starts -->
      <v-tab-item>
        <v-card class="pl-7 pr-6 pt-5 pb-5 noCardBorder" >
          <v-form ref='form' v-model='valid' lazy-validation>
              <v-row>
                <v-col>
                  <v-text-field
                    v-model='editedItem.name' :rules="jurisdictionRules" validate-on-blur
                    :maxlength='maxLength'
                    hint='The current Jurisdiction name.'
                    label='Jurisdiction name*' required
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field
                    v-model='editedItem.knownAs'
                    hint='If the Jurisdiction name has formally changed then include the former name.'
                    :maxlength='maxLength'
                    label='Formerly Known As'
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field
                    v-model='editedItem.fips'
                    hint='The 5-digit census code for the Jurisdiction.'
                    :maxlength='max'
                    label='FIPS'
                    :rules="fipsRules"
                    clearable
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-autocomplete validate-on-blur
                    v-model='editedItem.countryId'
                    @change='filterState'
                    :rules='countryRules'
                    :items='countryList'
                    item-text='name'
                    item-value='id'
                    label='Country*'
                    required
                    return-object
                    persistent-hint
                    hint="The country that the Jurisdiction resides in."
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-autocomplete
                    v-model='editedItem.stateId'
                    @change='filterCounty'
                    :disabled="!isEditingState"
                    :rules='stateRules'
                    :items="stateList.length >= 1 ? stateList : []"
                    item-text='name'
                    item-value='id'
                    label='State*'
                    persistent-hint
                    hint='The state that the Jurisdiction resides in'
                    required
                  ></v-autocomplete>
                  <span v-if="stateErrorCheck" class="caption fonte-weigth-light red--text">{{stateError}}</span>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-autocomplete
                    multiple
                    chips
                    v-model='editedItem.selectedCounty'
                    :disabled="!isEditingCounty"
                    :items="counties.length >= 1 ? counties : []"
                    item-text='name'
                    item-value='id'
                    label='County'
                  >
                  <template v-slot:selection="item">
                    <v-chip
                    small
                    label
                    close
                    color="grey lighten-1"
                    @click="item.select"
                  @click:close="removeCounty(item)"
                  >{{item.item.name}}</v-chip>
                    </template>
                  </v-autocomplete>
                  <span v-if="countyErrorCheck" class="caption fonte-weigth-light red--text">{{countyError}}</span>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-autocomplete
                    v-model='editedItem.profileId'
                    :items="adoptionProfileList"
                    item-text='name'
                    item-value="id"
                    label='Adoption Profile'
                    persistent-hint
                    clearable
                    hint=' Select from the dropdown how the Jurisdiction handles the adoption process.'
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-autocomplete @change="amendmentAllowed"
                    v-model='editedItem.amendmentsAllowed'
                    :items="['NA', 'YES', 'NO']"
                    label='Amendments Allowed'
                    persistent-hint
                    hint='Will the Jurisdiction adoption allow amendments YES / NO?'
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-autocomplete
                    :disabled="!isEditing"
                    @change="amendmentMadeAllowed"
                    hint="Amendments have been made YES / NO."
                    v-model='editedItem.amendmentsMade'
                    :items="['NA', 'YES', 'NO']"
                    item-text='name'
                    item-value='id'
                    label='Amendments Made'
                    persistent-hint
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field validate-on-blur
                    :disabled="!isEditingAmendments"
                    v-model='editedItem.amendments'
                    hint="Please select 'Amendments Made' as 'Yes' to edit this field."
                    label='Amendments'
                    :rules = "!isEditingAmendments ? undefined : amendmentRules"
                    required
                    persistent-hint
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field type="url" :rules='urlRules' validate-on-blur
                    v-model='editedItem.url'
                    hint='The Jurisdiction home website.'
                    label='Code Office URL'
                    clearable
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-file-input
                  accept="image/png, image/jpg"
                  label='Attach Logo File'
                  persistent-hint
                  hint="Attach an image of your logo. Recommended dimensions 250*100px"
                  v-model="chosenFile"
                  :rules='[IsValidImage]'
                  @change="importLogoFile"
                  clearable
                  >
                  </v-file-input>
                </v-col>
              </v-row>
              <v-row v-if="editedItem.logoUrl" >
                <v-col>
                  <v-img :src="logoImageExist ? editedItem.logoUrl :undefined"
                  alt='Logo'
                  aspect-ratio="1"
                  max-width="50"
                  max-height="50">
                  </v-img>
                  <span style="max-width: 80px;" class="caption d-inline-block text-truncate font-weight-regular">{{logoName}}</span>
                  <br/>
                  <v-btn title="Delete Logo" v-if="editedItem.logoUrl" @click.stop="removeDialog = true" x-small :loading="removeImageLoader" >Delete</v-btn>
                    <v-dialog
                      v-model="removeDialog"
                      max-width="320"
                    >
                      <v-card>
                        <v-card-title class="headline"></v-card-title>
                        <v-card-text class="font-weight-medium" >
                          <p class="rmImgDialog" >Are you sure you want to delete image?</p>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>

                          <v-btn
                            color="error darken-1"
                            text
                            @click="removeDialog = false"
                          >
                            No
                          </v-btn>

                          <v-btn
                            color="green darken-1"
                            text
                            @click="removeImage()"
                          >
                            Yes
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-autocomplete
                  multiple
                  label='Postal Code'
                  hint="Please add Postal Code."
                  v-model="editedItem.postalCodeId"
                  :items="postalList"
                  item-text="postalCode"
                  item-value="id"
                  chips
                  >
                    <template v-slot:selection="item">
                    <v-chip
                    small
                    label
                    close
                    color="grey lighten-1"
                    @click="item.select"
                  @click:close="remove(item)"
                  >{{item.item.postalCode}}</v-chip>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-icon @click="addPostalCodeBtn">mdi-plus</v-icon>
                <v-dialog v-if="addPostalDialog" v-model='addPostalDialog'>
                <template>
                  <add-postal-code @resetPostalDialog='addPostalDialog = $event' :addPostalDialogProp = 'addPostalDialog'></add-postal-code>
                </template>
                </v-dialog>
              </v-row>
              <v-row>
                <v-col >
                  <v-select
                    v-model='editedItem.status'
                    :items="statusItems"
                    label="Status*"
                    :rules="statusValidationRules"
                    item-text="statusText"
                    item-value="statusVal"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-textarea
                    v-model='editedItem.adoptionDescription'
                    label="Adoption Description"
                    hint="Add Adoption Description"
                    placeholder="Add Adoption Description"
                    clearable
                    dense
                    rows=3
                    filled
                  ></v-textarea>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-textarea
                    v-model='editedItem.usefulLinks'
                    label="Useful Links"
                    hint="Add legend and link in pair, like legend1||link1, legend2||link2. For multiple entry use comma(,) as separated"
                    placeholder="Add Useful Links"
                    persistent-hint
                    clearable
                    dense
                    rows=3
                    filled
                  ></v-textarea>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field disabled v-model='editedItem.latitude'
                    label='Latitude'></v-text-field>
                  </v-col>
              </v-row>
              <v-row>
                <v-col>
                    <v-text-field  disabled v-model='editedItem.longitude'
                    label='Longitude'></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field disabled v-model='editedItem.createdBy'
                  label='Created By'></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field disabled v-model='editedItem.createdDate'
                  label='Created On'></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col v-if="editedItem.createdDate !== editedItem.modifiedDate">
                  <v-text-field disabled v-model='editedItem.modifiedBy'
                  label='Modified By'></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col v-if="editedItem.createdDate !== editedItem.modifiedDate" cols='8' sm='4' md='4' lg='5'>
                  <v-text-field  disabled v-model='editedItem.modifiedDate'
                  label='Modified On'></v-text-field>
                </v-col>
              </v-row>
              <v-card-actions>
                <small color="primary">*indicates required fields</small>
                <v-spacer></v-spacer>
                <v-btn :loading='btnLoader' outlined class='fontcolor' @click='save'>
                  <v-icon dark>mdi-check</v-icon>Save
                </v-btn>
              </v-card-actions>
            </v-form>
        </v-card>
      </v-tab-item>
      <!-- Tab #3 ends -->
    </v-tabs>
  </div>
  <div v-else>
    <h1 class="mt-6 text-center" >Invalid edit parameter!</h1>
  </div>
</template>

<script>
import CONSTANTS from './../../../../config/constant'
import AddPostalCode from './ManageAddPostalCode'
import MappedAdoptionTable from './../../adoptions/adoptioneditforms/MappedAdoptionListing'
import AdminActivityByEntity from './../activitybyentities/ActivityByEntity'

export default {
  name: 'AdminEditJurisdiction',
  data: () => ({
    removeImageLoader: false,
    removeDialog: false,
    activeTab: 3,
    ADD_NEW_ADOPTION: 'MANAGE ADOPTION(S)',
    btnLoader: false,
    auditLogLoader: true,
    invalidEditParam: false,
    formTitle: CONSTANTS.EDIT_JURISDICTION,
    valid: true,
    maxLength: 50,
    max: 5,
    chosenFile: undefined,
    amendmentsMax: 100,
    isEditingState: false,
    totalAdoptions: 0,
    isEditingCounty: false,
    isEditingAmendments: false,
    stateErrorCheck: false,
    countyErrorCheck: false,
    isEditing: false,
    countyError: false,
    stateError: false,
    addPostalDialog: false,
    jurisdictionRules: [
      v => !!v || 'Jurisdiction name is required.'
    ],
    knownAsRules: [v => {
      if (v && !/^[A-Za-z. ]+$/.test(v)) {
        return 'Invalid input. Only characters (A-Z, a-z), period and space allowed!'
      } else {
        return true
      }
    }],
    countryRules: [
      v => !!v || 'Country name is required.'],
    stateRules: [
      v => !!v || 'State name is required.'],
    statusValidationRules: [
      v => !!v || 'Status is required.'
    ],
    fipsRules: [v => {
      if (v && !/^[0-9]+$/.test(v)) {
        return 'Invalid input. Only 5-digit numeric value (0-9) is allowed!'
      } else {
        return true
      }
    }, v => {
      if (v && v.length !== 5) {
        return 'Invalid input. Only 5-digit numeric value (0-9) is allowed!'
      } else {
        return true
      }
    }],
    urlRules: [v => {
      if (v && !/(http[s]?:\/\/)?[^\s(["<,>]*\.[^\s[",><]+$/.test(v)) {
        return 'Please enter a valid URL'
      } else {
        return true
      }
    }],
    amendmentRules: [v => {
      if (v && !/(http[s]?:\/\/)?[^\s(["<,>]*\.[^\s[",><]+$/.test(v)) {
        return 'Please enter a valid URL'
      } else if (v === '') {
        return 'Please enter a valid URL'
      } else {
        return true
      }
    }],
    logoRules: [v => {
      if (v !== {}) {
        const val = v.name
        if (val && val !== undefined && val !== null &&
        val.slice(val.lastIndexOf('.') + 1) !== 'png' &&
        val.slice(val.lastIndexOf('.') + 1) !== 'jpg' &&
        val.slice(val.lastIndexOf('.') + 1) !== 'PNG' &&
        val.slice(val.lastIndexOf('.') + 1) !== 'JPG' &&
        val.slice(val.lastIndexOf('.') + 1) !== 'jpeg' &&
        val.slice(val.lastIndexOf('.') + 1) !== 'JPEG') {
          return 'Invalid Input. Excepted file formats are .jpg and .png'
        } else {
          return true
        }
      }
    }],
    amendments: [value => !!value || 'Amendments is required.'],
    defaultStatus: CONSTANTS.DEFAULT_RECORDS_STATUS,
    statusValues: CONSTANTS.DEFAULT_RECORDS_STATUS_VALUE,
    defaultStatusItems: CONSTANTS.RECORDS_STATUS,
    statusItems: [
      { statusText: 'Inactive', statusVal: 1 },
      { statusText: 'Published', statusVal: 2 }
    ],
    editedItem: {
      id: '',
      name: '',
      knownAs: '',
      countryId: '',
      fips: '',
      stateId: '',
      countyId: [],
      selectedCounty: [],
      profileId: '',
      profileName: 'NA',
      amendmentsAllowed: 'NA',
      amendmentsMade: 'NA',
      amendments: '',
      jurisdictionInput: '',
      url: '',
      createdBy: '',
      createdDate: '',
      modifiedBy: '',
      modifiedDate: '',
      postalCodeId: [],
      status: '',
      latitude: '',
      longitude: '',
      adoptionDescription: '',
      usefulLinks: ''
    },
    defaultItem: {
      id: '',
      profileName: 'NA',
      amendmentsAllowed: 'NA',
      amendmentsMade: 'NA',
      selectedCounty: [],
      amendments: '',
      countryId: '',
      stateId: '',
      name: '',
      fips: '',
      countyId: [],
      profileId: '',
      knownAs: '',
      jurisdictionInput: '',
      url: '',
      adoptionDescription: '',
      usefulLinks: '',
      status
    }
  }),
  computed: {
    activityLogs () {
      return this.activityLogItems
    },
    dialog () {
      return this.editDialogProp
    },
    countryList () {
      let cList = this.$store.getters['CountryModule/fetchCountryList']
      if (Object.keys(cList).length !== 0) {
        let newCList = this.$globalStates.makeUSAAsFirstItem(cList)
        return newCList
      } else {
        return cList
      }
    },
    stateList () {
      return this.$store.getters['StateModule/fetchStateList']
    },
    counties () {
      return this.$store.getters['CountyModule/fetchCountyList']
    },
    adoptionProfileList () {
      let adoptionList = this.$store.getters['AdoptionProfileModule/fetchAdoptionProfileList']
      if (adoptionList.length > 0) {
        let newAdoptionList = this.$globalStates.makeNAAsFirstItem(adoptionList)
        return newAdoptionList
      } else {
        return adoptionList
      }
    },
    logoName () {
      const logo = this.editedItem.logoUrl
      let logoName = this.$globalStates.fetchImgNameFromImgURL(logo)
      return logoName
    },
    postalList () {
      return this.$store.getters['PostalCodeModule/fetchPostalCodeList']
    },
    jurisdictionId () {
      return this.editedItem.id
    }
  },
  components: {
    'add-postal-code': AddPostalCode,
    'mapped-adoption-table': MappedAdoptionTable,
    'admin-activity-by-entity': AdminActivityByEntity
  },
  mounted () {
    this.activeTab = (this.$globalFromValidation.paramIsInNumFormat(this.$route.params.tabId) - 1)
    this.initialize()
  },
  methods: {
    initialize () {
      /**
       * Check if id is valid number of not else set a invalid parama flag true
       */
      let idToGetInfo = this.$globalFromValidation.paramIsInNumFormat(this.$route.params.id)
      if (idToGetInfo > 0) {
        // Fetch data by id for edit
        new Promise((resolve, reject) => {
          this.$store.dispatch('JurisdictionModule/getJurisdictionDetailsById', { resolve, reject, idToGetInfo })
        }).then((responseData) => {
          this.editedItem = Object.assign({}, responseData.list[0])
          this.loading = false
          let adoptionLevel = 3
          let adoptionLevelFor = responseData.list[0].id
          let adoptionName = responseData.list[0].name
          this.$store.commit('AdoptionModule/setAdoptionData', { adoptionLevel, adoptionLevelFor, adoptionName })
          this.selectedJurisdiction = this.editedItem
          this.editItem(this.selectedJurisdiction)
          this.fetchPostalCode()
        }).catch(({ response }) => {
          this.loading = false
          this.invalidEditParam = true
        })
        new Promise((resolve, reject) => {
          this.$store.dispatch('PostalCodeModule/getPostalCodeList', {
            resolve,
            reject,
            status
          })
        })
          .then(responseData => {
          // add loader on button if required
          })
          .catch(response => {
          // add loader on button if required
          })
      } else {
        this.invalidEditParam = true
      }
    },
    /**
     * Function to send user back to listing page
     */
    backToListingPage () {
      this.$router.push({ name: 'AdminJurisdictions' })
    },
    // fetch edited items postal Code
    fetchPostalCode () {
      new Promise((resolve, reject, id = this.editedItem.id) => {
        this.$store.dispatch('JurisdictionModule/getJurisdictiongetMapPostalCode', {
          resolve,
          reject,
          id
        })
      })
        .then(responseData => {
          let list = responseData.list
          this.editedItem.postalCodeId = list.map(element => {
            return element.id
          })
          // add loader on button if required
        })
        .catch(response => {
          // add loader on button if required
        })
    },
    // Fetch state based on country ID selected from the dropdown on click of edit icon
    filterStateOnEditForm () {
      let fetchOnlyPublished = CONSTANTS.DEFAULT_RECORDS_STATUS_VALUE.Published
      const countryId = this.editedItem.countryId.id === undefined ? this.editedItem.countryId : this.editedItem.countryId.id
      new Promise((resolve, reject) => {
        this.$store.dispatch('StateModule/getStateList', {
          resolve,
          reject,
          countryId,
          fetchOnlyPublished
        })
      })
        .then(responseData => {
          this.filterCountyOnEditForm()
          // add loader on button if required
        })
        .catch(response => {
          this.isEditingCounty = false
          this.isEditingState = false
          this.editedItem.stateId = null
          this.editedItem.countyId = null
          this.countyErrorCheck = false
          this.stateErrorCheck = true
          this.stateError = CONSTANTS.NO_STATE_IS_AVAILABLE_FOR_THE_SELECTED_COUNTRY
          // add loader on button if required
        })
    },
    // Filter county on click of edit icon
    filterCountyOnEditForm () {
      let fetchOnlyPublished = CONSTANTS.DEFAULT_RECORDS_STATUS_VALUE.Published
      if (this.editedItem.stateId) {
        this.isEditingCounty = true
      } else {
        this.isEditingCounty = false
      }
      const countryId = this.editedItem.countryId.id === undefined ? this.editedItem.countryId : this.editedItem.countryId.id
      const stateId = this.editedItem.stateId
      new Promise((resolve, reject) => {
        this.$store.dispatch('CountyModule/getCountyList', {
          resolve,
          reject,
          countryId,
          stateId,
          fetchOnlyPublished
        })
      })
        .then(responseData => {
          this.editedItem.countyId = this.editedItem.countyId ? this.editedItem.countyId : ''
          this.countyErrorCheck = false
          // add loader on button if required
        })
        .catch(response => {
          this.isEditingCounty = false
          this.editedItem.countyId = []
          this.countyErrorCheck = true
          this.countyError = CONSTANTS.NO_COUNTY_IS_AVAILABLE_FOR_THE_SELECTED_STATE
          // add loader on button if required
        })
    },
    // Fetch state based on country ID selected from the dropdown
    filterState () {
      let fetchOnlyPublished = CONSTANTS.DEFAULT_RECORDS_STATUS_VALUE.Published
      if (this.editedItem.countryId) {
        this.isEditingState = true
      } else {
        this.isEditingState = false
      }
      const countryId = this.editedItem.countryId.id === undefined ? this.editedItem.countryId : this.editedItem.countryId.id
      new Promise((resolve, reject) => {
        this.$store.dispatch('StateModule/getStateList', {
          resolve,
          reject,
          countryId,
          fetchOnlyPublished
        })
      })
        .then(responseData => {
          this.editedItem.countyId = []
          this.isEditingCounty = false
          this.stateErrorCheck = false
          // this.filterCounty()
          // add loader on button if required
        })
        .catch(response => {
          this.isEditingCounty = false
          this.isEditingState = false
          this.editedItem.stateId = null
          this.editedItem.countyId = null
          this.countyErrorCheck = false
          this.stateErrorCheck = true
          this.stateError = CONSTANTS.NO_STATE_IS_AVAILABLE_FOR_THE_SELECTED_COUNTRY
          // add loader on button if required
        })
    },
    // Fetch state based on country ID selected from dropdown
    filterCounty () {
      let fetchOnlyPublished = CONSTANTS.DEFAULT_RECORDS_STATUS_VALUE.Published
      if (this.editedItem.stateId) {
        this.isEditingCounty = true
      } else {
        this.isEditingCounty = false
      }
      const countryId = this.editedItem.countryId.id === undefined ? this.editedItem.countryId : this.editedItem.countryId.id
      const stateId = this.editedItem.stateId
      new Promise((resolve, reject) => {
        this.$store.dispatch('CountyModule/getCountyList', {
          resolve,
          reject,
          countryId,
          stateId,
          fetchOnlyPublished
        })
      })
        .then(responseData => {
          this.editedItem.countyId = this.editedItem.countyId ? this.editedItem.countyId : []
          this.countyErrorCheck = false
          // add loader on button if required
        })
        .catch(response => {
          this.isEditingCounty = false
          this.editedItem.countyId = []
          this.countyErrorCheck = true
          this.countyError = CONSTANTS.NO_COUNTY_IS_AVAILABLE_FOR_THE_SELECTED_STATE
          // add loader on button if required
        })
    },
    editItem (jurisdiction) {
      this.editedIndex = this.selectedEditedIndex
      this.editedItem = Object.assign({}, jurisdiction)
      this.isEditing = this.editedItem.amendmentsAllowed === 'YES' ? true : null
      this.isEditingAmendments = this.editedItem.amendmentsMade === 'YES' ? true : null
      this.isEditingState = true
      this.isEditingCounty = true
      this.filterStateOnEditForm()
      this.logoImageExist()
      // this.$emit('resetDialog', this.editDialog)
    },
    logoImageExist () {
      let img = this.editedItem.logoUrl
      if (img === undefined) { return false }
      if (img.includes('png') || img.includes('PNG') ||
      img.includes('jpg') || img.includes('JPG') ||
      img.includes('jpeg') || img.includes('JPEG')) {
        return true
      } else {
        this.editedItem.logoUrl = undefined
        return false
      }
    },
    amendmentAllowed () {
      if (this.editedItem.amendmentsAllowed === 'YES') {
        this.isEditing = true
      } else {
        this.isEditingAmendments = false
        this.isEditing = false
        this.editedItem.amendmentsMade = 'NA'
        this.editedItem.amendments = 'NA'
      }
      return this.isEditing
    },
    amendmentMadeAllowed () {
      if (this.editedItem.amendmentsMade === 'YES') {
        this.isEditingAmendments = true
      } else {
        this.isEditingAmendments = false
        this.editedItem.amendments = 'NA'
      }
      return this.isEditingAmendments
    },
    importLogoFile (e) {
      if (!this.chosenFile) {
        this.chosenFile = undefined
      }
      this.chosenFile = e
      return this.chosenFile
    },
    addPostalCodeBtn () {
      this.addPostalDialog = true
    },
    remove (item) {
      const index = this.editedItem.postalCodeId.indexOf(item.item.id)
      if (index >= 0) this.editedItem.postalCodeId.splice(index, 1)
    },
    removeCounty (item) {
      let index = item.item.id
      this.editedItem.selectedCounty.map((element, key) => {
        if (index === element.id) {
          this.editedItem.selectedCounty.splice(key, 1)
        }
      })
    },
    save () {
      if (this.$refs.form.validate()) {
        this.btnLoader = true
        let countyId = []
        if (this.editedItem.selectedCounty !== undefined) {
          this.editedItem.selectedCounty.map(element => {
            if (element.id === undefined) {
              countyId.push(element)
            } else {
              countyId.push(element.id)
            }
          })
        } else {
          this.editedItem.selectedCounty = ''
        }
        let editJurisdictionData = this.editedItem
        let editedData = new FormData()
        editedData.append('logo', (this.chosenFile !== undefined) ? this.chosenFile : '')
        editedData.append('name', editJurisdictionData.name)
        editedData.append('countryId', this.editedItem.countryId.id ? this.editedItem.countryId.id : this.editedItem.countryId)
        editedData.append('stateId', editJurisdictionData.stateId)
        editedData.append('countyId', countyId)
        editedData.append('fips', (editJurisdictionData.fips !== null) ? editJurisdictionData.fips : '')
        editedData.append('formerlyKnownAs', (editJurisdictionData.knownAs !== undefined) ? editJurisdictionData.knownAs : '')
        editedData.append('adoptionProfile', editJurisdictionData.profileId === undefined ? '' : editJurisdictionData.profileId)
        editedData.append('amendmentsAllowed', editJurisdictionData.amendmentsAllowed)
        editedData.append('amendmentsMade', editJurisdictionData.amendmentsMade)
        let codeOffUrl = editJurisdictionData.url
        if (editJurisdictionData.url === null) {
          codeOffUrl = ''
        }
        editedData.append('url', (codeOffUrl !== undefined ? codeOffUrl : ''))
        editedData.append('amendments', editJurisdictionData.amendments)
        editedData.append('userId', this.$store.getters['AuthModule/getUserId'])
        editedData.append('id', editJurisdictionData.id)
        editedData.append('logoUrl', editJurisdictionData.logoUrl)
        editedData.append('postalCodeId', editJurisdictionData.postalCodeId === undefined || editJurisdictionData.postalCodeId === null ? '' : editJurisdictionData.postalCodeId)
        editedData.append('status', editJurisdictionData.status)
        editedData.append('adoptionDescription', (editJurisdictionData.adoptionDescription === undefined || editJurisdictionData.adoptionDescription === null) ? '' : editJurisdictionData.adoptionDescription)
        editedData.append('usefulLinks', (editJurisdictionData.usefulLinks === undefined || editJurisdictionData.usefulLinks === null) ? '' : editJurisdictionData.usefulLinks)
        new Promise((resolve, reject) => {
          this.$store.dispatch('JurisdictionModule/editJurisdictionItem', {
            resolve,
            reject,
            editedData
          })
        })
          .then(responseData => {
            this.$globalStates.notification.text = responseData.responseMessage
            this.btnLoader = false
            this.$globalStates.notification.init_notifications = true
            this.$globalStates.notification.type = 'green'
            // reinitialize so that image element can refelect after success
            this.initialize()
          })
          .catch(response => {
            this.$globalStates.notification.text = response.responseMessage
            this.btnLoader = false
            this.$globalStates.notification.init_notifications = true
            this.$globalStates.notification.type = 'red'
          })
      }
    },
    IsValidImage (v) {
      if (v) {
        const val = v.name
        if (
          val &&
          val !== undefined &&
          val !== null &&
          val.slice(val.lastIndexOf('.') + 1) !== 'png' &&
          val.slice(val.lastIndexOf('.') + 1) !== 'jpg' &&
          val.slice(val.lastIndexOf('.') + 1) !== 'PNG' &&
          val.slice(val.lastIndexOf('.') + 1) !== 'JPG' &&
          val.slice(val.lastIndexOf('.') + 1) !== 'jpeg' &&
          val.slice(val.lastIndexOf('.') + 1) !== 'JPEG'
        ) {
          return 'Invalid Input. Excepted file formats are .jpg and .png'
        } else {
          return true
        }
      } else {
        return true
      }
    },
    bulkEditUrl (id, adoptionLevel) {
      this.$router.push({ name: 'BulkAdoption', params: { adoptionLevel: CONSTANTS.BULK_ADOPTION_URL[adoptionLevel], id: id } })
    },
    removeImage () {
      // call to remove image
      const rmData = {
        userId: this.$store.getters['AuthModule/getUserId'],
        id: this.editedItem.id,
        adoptionLevel: 3
      }
      new Promise((resolve, reject) => {
        this.$store.dispatch('CodeBookModule/deleteImage', {
          resolve,
          reject,
          rmData
        })
      })
        .then(responseData => {
          this.$globalStates.notification.text = this.$globalFromValidation.getErrorMessageText(responseData.responseMessage)
          this.$globalStates.notification.init_notifications = true
          this.$globalStates.notification.type = 'green'
        })
        .catch(response => {
          this.$globalStates.notification.text = this.$globalFromValidation.getErrorMessageText(response.responseMessage)
          this.$globalStates.notification.init_notifications = true
          this.$globalStates.notification.type = 'red'
        }).finally(() => {
          this.editedItem.logoUrl = ''
          this.removeDialog = false
          this.chosenFile = ''
        })
    }
  }
}
</script>
